/**
 * tenantgoodstype(商户下设备类型信息[商品类别])
 */
import axios from '@/api/http'; // 导入http中创建的axios实例
import base from '@/api/base'; // 导入接口域名列表
const common = {
  //GET /tenantgoodstype/query PC----根据tenantId查询信息-----ygt
  tenantgoodstype(){
    return axios.get(`${base.baseURL}tenantgoodstype/query`)
  }
}
export default common;



// WEBPACK FOOTER //
// ./src/network/common.js